const values = [
  {
    icon: "ri-focus-3-line",
    title: "按情绪挑番",
    text: "每部番都标注情绪标签与适用场景，睡前、下饭、深度治愈一目了然。",
  },
  {
    icon: "ri-git-merge-line",
    title: "持续更新",
    text: "热门片单与专题每周更新，追更动态紧跟新番节奏，追更不迷路。",
  },
  {
    icon: "ri-sailboat-line",
    title: "不夹带私货",
    text: "综合评分、口碑与编辑部试看体验，客观呈现每一部治愈番的真实质感。",
  },
];

const testimonials = [
  {
    name: "阿橘",
    role: "社畜日常党",
    text: "下班累到不想动的时候，就打开小狗看番挑一部，看完真的觉得被治愈了。",
  },
  {
    name: "Momo酱",
    role: "萌系爱好者",
    text: "萌系片单太对味了！向阳素描、点兔都在，编辑部懂我！",
  },
  {
    name: "咸鱼君",
    role: "周末露营党",
    text: "顺着摇曳露营的推荐入坑，现在每周末都想出去看山看水。",
  },
];

function About() {
  return (
    <section id="about" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <span className="text-xs font-semibold tracking-widest text-accent-600 uppercase">
            About
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">
            小狗看番，陪你慢慢看番
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-700">
            小狗看番是一个专注治愈系、日常系、萌系与温馨动画的内容平台。我们希望把那些
            「看完心里暖暖的」作品好好整理起来，让每一个想放松心情的人，都能用最短的时间
            找到今晚想看的番。我们的内容原则很简单：真诚推荐、持续更新、按情绪分类，绝不
            用夸张标题误导你。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-12">
          {values.map((v) => (
            <div
              key={v.title}
              className="rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                <i className={`${v.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">
                {v.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                {v.text}
              </p>
            </div>
          ))}
        </div>

        <div className="rounded-lg bg-background-50 border border-background-200/70 p-6 md:p-8">
          <div className="mb-6 flex items-center gap-2">
            <i className="ri-chat-heart-fill text-2xl text-accent-500"></i>
            <h3 className="font-heading text-xl text-foreground-950">
              读者口碑
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {testimonials.map((t) => (
              <div
                key={t.name}
                className="rounded-lg bg-background-100 border border-background-200/70 p-5"
              >
                <div className="flex items-center gap-1 text-secondary-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                  “{t.text}”
                </p>
                <div className="mt-4 flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-100 text-accent-700 text-sm font-semibold">
                    {t.name.slice(0, 1)}
                  </span>
                  <div>
                    <div className="text-sm font-medium text-foreground-950">
                      {t.name}
                    </div>
                    <div className="text-xs text-foreground-600">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;